import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DISHES_USED_METADATA_COUNTS_QUERY } from '../graphql/queries'
import { FETCH_DISHES_USED_METADATA_COUNTS } from '../redux/action-types'

const useDishesUsedMetadataCountsQuery = filters => {
  const dispatch = useDispatch()

  const {
    isUsedMetadataCountsLoading: isLoading,
    usedMetadataCounts: data,
    usedMetadataCountsError: error,
  } = useSelector(store => store.dishes.dishes)

  const refetch = useCallback(
    filters =>
      apolloService.query({
        query: DISHES_USED_METADATA_COUNTS_QUERY,
        variables: {
          filters,
        },
        dispatch,
        action: FETCH_DISHES_USED_METADATA_COUNTS,
      }),
    [dispatch],
  )

  useEffect(() => {
    refetch(filters)
  }, [filters, refetch])

  return { isLoading, error, data }
}

export default useDishesUsedMetadataCountsQuery
